module.exports = __webpack_public_path__ + "static/1-c9c1356d9ea010d59308111e463dcabe.jpeg";